import { colors, fonts } from '@grupoboticario/flora-tokens/associacaoGrupoBoticario/web/ds'

export const associacaoGrupoBoticario = {
  colors,
  fonts,
}
